import { render, staticRenderFns } from "./InactiveAdditionalRecipient.vue?vue&type=template&id=264d5d02"
import script from "./InactiveAdditionalRecipient.vue?vue&type=script&lang=js"
export * from "./InactiveAdditionalRecipient.vue?vue&type=script&lang=js"
import style0 from "./InactiveAdditionalRecipient.vue?vue&type=style&index=0&id=264d5d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports